import { BrushNode } from "./BrushNode";
import { curveThroughPoints } from "./utils";

const WIND = 0;

const defaultSettings = {
  friction: 0.36,
  length: 10,
  radius: 10,
  spacing: 20,
  thickness: 20,
  color: { h: 0, s: 0, l: 0.1 }
};

const HALF_PI = Math.PI / 2;


class BrushHair {
  constructor(options) {
    const lengthMultiplier = 8;
    this.length = options.length * lengthMultiplier || defaultSettings.length * lengthMultiplier;
    this.radius = options.radius || defaultSettings.radius;
    this.spacing = options.spacing || defaultSettings.spacing;
    this.friction = options.friction || defaultSettings.friction;
    this.thickness = options.thickness || defaultSettings.thickness;
    this.color = options.color || defaultSettings.color;
    this.shade = 0.85 + Math.random() * 0.25;
    this.moveProgress = 0;
    this.maxLength = this.length;
    this.limit = this.maxLength;
    this.radiusMultiplier = 4;
    this.baseFriction = 0.36;
    this.baseHairLength = 10;
    this.gravity = 0;
    this.roundMode = false;

    this.nodes = [];
    this.outer = [];
    this.inner = [];
    this.theta = [];

    for (let i = 0; i < this.length; i++) {
      this.nodes.push(new BrushNode());
    }
  }

  move(x, y, instant) {
    this.nodes[0].x = x;
    this.nodes[0].y = y;
    if (instant && this.length > 1) {
      for (let i = 1; i < this.length; i++) {
        this.nodes[i].x = x;
        this.nodes[i].y = y;
      }
    }
  }

  changeOptions(options, hairLength) {
    this.baseHairLength = hairLength;
    this.thickness = options.thickness;
    this.radiusMultiplier = options.lineRadius;
    this.baseFriction = options.friction;
    this.gravity = options.gravity;
    this.roundMode = options.round;
  }

  changeColor(color) {
    this.color.h = color.h;
    this.color.s = color.s;
    this.color.l = color.l;
  }

  update() {
    let i, s, c, dx, dy, da, px, py, prev = this.nodes[0];
    let radius = this.radius * this.radiusMultiplier;
    const step = radius / this.length;

    this.outer = [];
    this.inner = [];
    this.theta = [];

    for (i = 1; i < this.length; i++) {
      const node = this.nodes[i];
      node.x += node.vx;
      node.y += node.vy;
      dx = prev.x - node.x;
      dy = prev.y - node.y;
      da = Math.atan2(dy, dx);
      px = node.x + Math.cos(da) * this.spacing * this.baseHairLength;
      py = node.y + Math.sin(da) * this.spacing * this.baseHairLength;
      node.x = prev.x - (px - node.x) + Math.random() * 1 - 0.5;
      node.y = prev.y - (py - node.y) + Math.random() * 1 - 0.5;
      node.vx = node.x - node.ox;
      node.vy = node.y - node.oy;
      node.vx *= this.friction * (1 - this.baseFriction);
      node.vy *= this.friction * (1 - this.baseFriction);
      node.vx += WIND;
      node.vy += this.gravity;
      node.ox = node.x;
      node.oy = node.y;
      s = Math.sin(da + HALF_PI);
      c = Math.cos(da + HALF_PI);
      if (i < this.limit) {
        this.outer.push({
          x: prev.x + c * radius,
          y: prev.y + s * radius
        });
        this.inner.unshift({
          x: prev.x - c * radius,
          y: prev.y - s * radius
        });
      }
      this.theta.push(da);
      radius -= step;
      prev = node;
    }
  }

  draw(ctx, outer = null, inner = null, color = this.color, shade = this.shade) {
    if (outer) {
      outer = outer.map(point => ({ x: point.x + ctx.canvas.width / 2, y: point.y + ctx.canvas.height / 2 }));
    } else {
      outer = this.outer;
    }
    if (inner) {
      inner = inner.map(point => ({ x: point.x + ctx.canvas.width / 2, y: point.y + ctx.canvas.height / 2 }));
    } else {
      inner = this.inner;
    }

    if (outer.length < 3) {
      return;
    }
    const startPoint = outer[0];
    const endPoint = inner[inner.length - 1];
    ctx.beginPath();
    ctx.moveTo(startPoint.x, startPoint.y);
    curveThroughPoints(outer, ctx);
    curveThroughPoints(inner, ctx);
    ctx.lineTo(endPoint.x, endPoint.y);
    ctx.closePath();

    const h = color.h;
    const s = color.s * 100;
    const l = color.l * 100 * shade;

    if (!this.roundMode) {
      ctx.fillStyle = 'hsl(' + h + ',' + s + '%,' + l + '%)';
      ctx.fill();
    }

    if (this.thickness > 2) {
      ctx.strokeStyle = 'hsl(' + h + ',' + s + '%,' + l + '%)';
      ctx.lineWidth = this.thickness;
      ctx.lineCap = 'round';
      ctx.lineJoin = this.roundMode ? 'round' : 'bevel';
      ctx.stroke();
    }

  }
}
export { BrushHair };





